import DataPortals from 'components/showcase/DataPortals.jsx'

export default function DataPortalsPage(){
  return(
    <DataPortals/>
  )
}

export async function getStaticProps() {
  return {
    props: {
      meta: {
        title: "Data Portals we've built",
        description: "Browse data portals designed and developed by our team.",
      },
    },
  };
};